// ... your code that runs before foundation initiation

// Fix for foundation stylesheets being picked up as "null" or "not an object",
// implementation from here: http://foundation.zurb.com/forum/posts/3189-foundation-5-orbit-slider-ie8-issue
// (function($) {
//     'use strict';

//     if (!Foundation.stylesheet) {
//         Foundation._style_element = $('<style></style>').appendTo('head')[0];
//         Foundation.stylesheet = Foundation._style_element.styleSheet;

//         if (Foundation.stylesheet) {
//             Foundation.stylesheet.cssRules = {
//                 length: 0
//             };

//             Foundation.stylesheet.insertRule = function(rule, index) {
//                 var media;
//                 var mediaMatch;
//                 var mediaRegex;
//                 var namespace;
//                 var ruleMatch;
//                 var ruleRegex;
//                 mediaRegex = /^\s*@media\s*(.*?)\s*\{\s*(.*?)\s*\}\s*$/;
//                 mediaMatch = mediaRegex.exec(rule);
//                 media = '';

//                 if (mediaMatch) {
//                     media = '@media ' + mediaMatch[1] + ' ';
//                     rule = mediaMatch[2];
//                 }

//                 ruleRegex = /^\s*(.*?)\s*\{\s*(.*?)\s*\}\s*$/;
//                 ruleMatch = ruleRegex.exec(rule);
//                 namespace = '' + media + ruleMatch[1];
//                 rule = ruleMatch[2];

//                 return this.addRule(namespace, rule);
//             };
//         } else if (window.console) {
//             console.log('Could not fix Foundation CSS rules...');
//         }
//     }
// })(jQuery);

// Accessible image sprites (modificat):
// https://www.paciellogroup.com/blog/2012/08/notes-on-accessible-css-image-sprites/

// function HCTest() {
//     'use strict';

//     var objDiv;
//     var strColor;
//     var objFlag;

//     // reference to img element used to check if images are disabled
//     objFlag = document.getElementById('flag');
//     if (objFlag === null) {
//         return;
//     }

//     // Create a test div
//     objDiv = document.createElement('div');

//     // Set its color style to something unusual
//     objDiv.style.color = 'rgb(31,41,59)';

//     // Attach to body so we can inspect it
//     document.body.appendChild(objDiv);

//     // Use standard means if available, otherwise use the IE methods

//     strColor = document.defaultView ? document.defaultView.getComputedStyle(objDiv, null).color : objDiv.currentStyle.color;

//     // get rid of extra spaces in result
//     // strColor = strColor.replace(/ /g,"");

//     // Delete the test DIV

//     document.body.removeChild(objDiv);

//     // Check if we got back what we set (strColor== ??) If not we are in high contrast mode
//     // Use .offsetwidth and .readyState (for IE) to check if images are enabled
//     // If either images are disabled or high contrast is enabled (or both) the CSS stylesheet link will not be added to the page and the visually hidden text will be displayed in place of the missing background image

//     if (!(((objFlag.offsetWidth === 1 && objFlag.readyState === 'complete') || (objFlag.offsetWidth === 1 && objFlag.readyState === undefined)) && (strColor === 'rgb(31,41,59)' || strColor === 'rgb(31, 41, 59)'))) {

//         var objHead = document.getElementsByTagName('head');
//         var objCSS = objHead[0].appendChild(document.createElement('link'));
//         objCSS.rel = 'stylesheet';
//         objCSS.href = '/media/css/alt.css';
//         // objCSS.type = 'text/css';
//     }
// }

// Safely initiate foundation now
// $(document).foundation();

// the rest of your code

// $(window).load(function() {
    // 'use strict';

    // accessible image sprites
    // HCTest();
// });

// mobile-nav
(function() {

    var mqm = window.matchMedia('(max-width: 1089px)');

    // get the button and menu nodes
    var button = document.querySelector('[aria-label="site"] button');
    var menu = button.nextElementSibling;

    // set initial (closed menu) states
    button.setAttribute('aria-expanded', 'false');
    button.hidden = false;
    if (mqm.matches) {
        menu.hidden = true;
    }

    $( window ).resize(function() {
        if (window.matchMedia('(min-width: 620px)').matches) {
            menu.hidden = false;
        }
    });

    button.addEventListener('click', function() {
        // toggle menu visibility
        var expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', String(!expanded));
        menu.hidden = expanded;
    });

})();

// sub-nav
if (document.querySelector('button#submenu')) {
    (function() {

        //var mqm = window.matchMedia('(max-width: 64em)');
        var mqm = window.matchMedia('(max-width: 1089px)');
        console.log(2);
        // get the button and menu nodes
        var button2 = document.querySelector('button#submenu');
        var submenu = button2.nextElementSibling;

        // set initial (closed menu) states
        button2.setAttribute('aria-expanded', 'false');
        button2.hidden = false;
        if (mqm.matches) {
            submenu.hidden = true;
        }

        $( window ).resize(function() {
            if (window.matchMedia('(min-width: 1089px)').matches) {
                submenu.hidden = false;
            }
        });

        button2.addEventListener('click', function() {
            // toggle menu visibility
            var expanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', String(!expanded));
            submenu.hidden = expanded;
        });

    })();
}

$(document).ready(function() {
    'use strict';

    // main-nav traiem el span que s'ha posat pel Houdini, perquè si no no funcionen els submenús
    //$('.main-nav li > span').remove();


    // http://heydonworks.com/practical_aria_examples/#submenus
    $('.main-nav ul ul').prev('a')
      .attr('aria-haspopup', 'true')
      .append('<span aria-hidden="true"> <svg width="10" height="7" viewBox="0 0 10 7" xmlns="http://www.w3.org/2000/svg"><title>Fill 6 Copy 5</title><path d="M5.29 6.77L.693 2.175 2.107.76 5.29 3.943 8.473.76l1.414 1.414z" fill-rule="evenodd"/></svg></span>');

    var showSubmenu = function(dropdown) {
      dropdown.attr('aria-hidden', 'false');
    };

    var hideSubmenu = function(dropdown) {
      dropdown.attr('aria-hidden', 'true');
    };

    $('.with-dropdowns > li > a').on('focus', function(e) {
      hideSubmenu($('[aria-label="submenu"]'));
    });

    $('[aria-haspopup]').on('click', function(e) {
      var submenu = $(this).next();
      showSubmenu(submenu);
      //$(submenu).find('li:first-child a').focus();
      return false;
    });

    $('[aria-haspopup]').hover(function() {
      showSubmenu($(this).next());
      $(this).off('click');
    });

    $('[aria-haspopup]').parents('li').mouseleave(function() {
      hideSubmenu($(this).find('[aria-label="submenu"]'));
    });

    // feature.js
    if (feature.svg) {
        $('html').addClass('svg');
    }


    // hamburgers
    var $hamburger1 = $(".hamburger--1");
    $hamburger1.on("click", function(e) {
      $hamburger1.toggleClass("is-active");
      $('.menu').toggleClass("js-open");
      $('body').toggleClass("js-menu-open");
    });
    var $hamburger2 = $(".hamburger--2");
    $hamburger2.on("click", function(e) {
      $hamburger2.toggleClass("is-active");
      $('.sub-nav').toggleClass("js-open");
      $('body').toggleClass("js-submenu-open");
    });


    // skip link (https://www.bignerdranch.com/blog/web-accessibility-skip-navigation-links/)
    // bind a click event to the 'skip' link
    $(".skip-link").click(function(event){

        // strip the leading hash and declare
        // the content we're skipping to
        var skipTo="#"+this.href.split('#')[1];

        // Setting 'tabindex' to -1 takes an element out of normal
        // tab flow but allows it to be focused via javascript
        $(skipTo).attr('tabindex', -1).on('blur focusout', function () {

            // when focus leaves this element,
            // remove the tabindex attribute
            $(this).removeAttr('tabindex');

        }).focus(); // focus on the content container
    });


    // Match Height
    $('.data-wrapper').matchHeight();
    $('.event-item').matchHeight();
    $('.column-block').matchHeight();
    $('.block-list__box').matchHeight();
    $('.colab-prj').matchHeight();
    $('.block-list--news .wrapper').matchHeight();
    $('.list-links-btn li').matchHeight();
    $('.list-links-btn2 li').matchHeight();
    $('.list-links-btn3 li').matchHeight();


    // canvi svg per png
    if (!feature.svg) {
        var imgs = document.getElementsByTagName('img');
        var endsWithDotSvg = /.*\.svg$/;
        var i = 0;
        var l = imgs.length;
        for (; i !== l; ++i) {
            if (imgs[i].src.match(endsWithDotSvg)) {
                imgs[i].src = imgs[i].src.slice(0, -3) + 'png';
            }
        }
    }


    // treure margin-bottom dels p>strong+ul
    $('p strong:only-child').each(function(){
        if($(this).parent().text() == $(this).text() && $(this).parent().next('ul').length) {
            $(this).parent().css('margin-bottom','0');
        }
    });


    // smooth scroll top
    $(window).scroll(function() {
      if ($(this).scrollTop() > 400) {
          $(".top").fadeIn();
      } else {
          $(".top").fadeOut();
      }
    });
    var headerHeight = 82; // fixed header height
    $(function() {
      $('a[href*="#"]:not([href="#"],[href="#ir"])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
          if (target.length) {
        	  if (window.matchMedia("(min-width: 64.0625em)").matches) {

        	    	$('html, body').animate({
  		              scrollTop: target.offset().top - headerHeight
  		            }, 1000);
        	  } else {
		            $('html, body').animate({
		              scrollTop: target.offset().top
		            }, 1000);
        	  }
            return false;
          }
        }
      });
    });


    // form inscripció cursos
    $('.js-inscripcion').before('<div class="row"><div class="column text-center"><a href="#" class="btn btn--solid-2 js-inscr-btn">Inscribirme</a></div></div>').addClass('is-hidden');
    $('.js-inscr-btn').click(function() {
      $('.js-inscripcion').removeClass('is-hidden');
      return false;
    });


    // sliders
    $('.slider').slick({
        dots: true,
        autoplay: true,
        fade: true,
        cssEase: 'linear',
        autoplaySpeed: 12000
    });
    if( $('.slider-logos').length) {
        $('.slider-logos').slick({
            dots: false,
            speed: 300,
            autoplay: true,
            autoplaySpeed: 12000,
            slidesToShow: 4,
            slidesToScroll: 4,
            responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
            ]
        });
    }
    // sticky header
    if (window.matchMedia('(min-width: 64.0625em)').matches) {
        // var lastScrollTop = 170;
        var lastScrollTop = 200;
        $(window).scroll(function(event){
            var st = $(this).scrollTop();
            if (st > lastScrollTop){
                $('.main-header').addClass('sticky');
                $('body').addClass('sticky-header');
            } else {
                $('.main-header').removeClass('sticky');
                $('body').removeClass('sticky-header');
            }
            // lastScrollTop = st;
        });
    }


    // custom file input (https://tympanus.net/codrops/2015/09/15/styling-customizing-file-inputs-smart-way/)
    /*
        By Osvaldas Valutis, www.osvaldas.info
        Available for use under the MIT License
    */

    ;( function( $, window, document, undefined )
    {
        $( '.inputfile' ).each( function()
        {
            var $input   = $( this ),
                $label   = $input.next( 'label' ),
                labelVal = $label.html();

            $input.on( 'change', function( e )
            {
                var fileName = '';

                if( this.files && this.files.length > 1 )
                    fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
                else if( e.target.value )
                    fileName = e.target.value.split( '\\' ).pop();

                if( fileName ) {
                  $label.find( 'span' ).html( fileName );
                  $label.find( 'img' ).remove();
                }
                else {
                  $label.html( labelVal );
                }
            });

            // Firefox bug fix
            $input
            .on( 'focus', function(){ $input.addClass( 'has-focus' ); })
            .on( 'blur', function(){ $input.removeClass( 'has-focus' ); });
        });
        $( '.btn-reemplazar' ).on( 'click', function( e ){
          var idButton   = $( this ).attr('id');
          console.log(idButton);

          const inputToClickBoth = document.getElementById('input-' + idButton);
          inputToClickBoth.click();
          // console.log(inputToClickBoth);
          e.preventDefault();
        });
        $( '.inputfileModifyOPE' ).each( function()
        {
            var $input   = $( this ),
                $label   = $input.next( 'label' ),
                labelVal = $label.html();

            // console.log(this.id);
            // console.log($label);
            // console.log(labelVal);
            $input.on( 'change', function( e )
            {
              console.log("somerthing");
              console.log('#descargar-'+this.id);
              $( '#descargar-'+this.id ).hide();
              $( '#archivo-reemplazado-'+this.id ).show();

            });

            // Firefox bug fix
            $input
            .on( 'focus', function(){ $input.addClass( 'has-focus' ); })
            .on( 'blur', function(){ $input.removeClass( 'has-focus' ); });
        });
    })( jQuery, window, document );



    // header search (http://adrianroselli.com/2015/12/responsive-progressive-accessible-vanilla-search.html)
    // Get the search field by ID
    var eID = document.getElementById("s1");

    // Declare the event object and set it to null
    var eventObj = null;

    // Add the event listeners I want to track
    eID.addEventListener("focus", checkSearch, false);
    eID.addEventListener("blur", checkSearch, false);
    eID.addEventListener("keydown", checkSearch, false);
	// per ie11
    $("label[for='s1']").on('click', function(e){
    	checkSearch(e);
    	return false;
    });

    function checkSearch(eventObj) {
      try {
        // Get the event type from the object
        var eventType = eventObj.type
        // Map the tab key to a variable
        var TABKEY = 9;
        // Get the search input text value
        var eIDval = eID.value;
        // Get the parent element
        var eIDparent = eID.parentElement;
        // Set a class since we are on it
        eIDparent.className = "notempty";
        // Get the button
        var eIDbutton = eIDparent.getElementsByTagName('button')[0];
        // Set the button tabindex
        eIDbutton.setAttribute('tabindex', '0');
        // If the text value is not blank
        if (eIDval != '') {
          // Give it a class that will stay
          eIDparent.className = "notempty";
        }
        // If the text value is blank
        else {
          // Check if focus has left the input first
          if (eventType == 'blur') {
            // Set tabindex on button to remove from flow
            eIDbutton.setAttribute('tabindex', '-1');
            // Remove the class
            eIDparent.className = "";
          }
          // Check if user hit a key
          if (eventType == 'keydown') {
            // See if the user hit the tab key
            if (eventObj.keyCode == TABKEY) {
              // Set tabindex on button to remove from flow
              eIDbutton.setAttribute('tabindex', '-1');
            }
          }
        }
      } catch (e) {
        console.log(e);
      }
    }


    // home counters
    if ($('#counters').length) {

    	var countersUpdated = 0;

    	function animateCounters() {
	        $('.counter-value').each(function() {
	          var $this = $(this),
	            countTo = $this.attr('data-count'),
                durationSpeed = 2500;
              if (countTo > 300) durationSpeed = 6000;
              if (countTo > 100) durationSpeed = 4500;
	          $({
	            countNum: $this.text()
	          }).animate({
	              countNum: countTo
	            },

	           {
	              duration: durationSpeed,
	              easing: 'swing',
	              step: function() {
	                $this.text(Math.floor(this.countNum));
	              },
	              complete: function() {
	                $this.text(this.countNum);
	              }

	           });
	        });

    	}

    	if ( $('#counters').is( ':in-viewport' ) ) {
    		$('#counters .num').html('0');
    		animateCounters();
    		countersUpdated = 1;
		}

    	$(window).scroll(function() {
    		if (countersUpdated == 0) {
    	    	if ( $('#counters').is( ':in-viewport' ) ) {
    	    		countersUpdated = 1;
    	    		$('#counters .num').html('0');
    	    		animateCounters();
    			}

    		}
		});
    }

    // show more items
    if ($("#showMoreItems").length) {
        $('.moreItems').hide();
        $("#showMoreItems").on('click', function(e){
            e.preventDefault();
            $("#showMoreItems").hide();
            $('.moreItems').fadeIn('slow');
            $.fn.matchHeight._maintainScroll = true;
            $.fn.matchHeight._update();
            return false;
        });
    }


    // toggle idiomes
    $('.lang-toggle').click(function() {
      $(this).toggleClass('close');
      $(this).next().toggleClass('is-hidden');
      return false;
    });
    $('.lang-list').mouseleave(function() {
      $(this).toggleClass('is-hidden');
    });


    // subscripció
    if ($("#subscripcio").length) {

        $(document).on('submit', "#subscripcio form", function(e){
            var postData = $(this).serializeArray();
            var formURL = $(this).attr("action");
            $.ajax(
            {
                url : formURL,
                type: "POST",
                data : postData,
                success:function(data, textStatus, jqXHR)
                {
                    $('#subscripcio .subscripcioContainer').html(data);
                },
                error: function(jqXHR, textStatus, errorThrown)
                {
                    $('#subscripcio .subscripcioContainer').html('error');
                }
            });
            e.preventDefault(); //STOP default action
        });
    }


    // àncores
    if (window.matchMedia("(min-width: 64.0625em)").matches) {
        // to top right away
        if ( window.location.hash ) scroll(0,0);
        // void some browsers issue
        setTimeout( function() { scroll(0,0); }, 1);

        $(function() {
            // *only* if we have anchor on the url
            if(window.location.hash) {

                // smooth scroll to the anchor id
                $('html, body').animate({
                    scrollTop: $(window.location.hash).offset().top - ($(".main-header").height() + 5)
                }, 1000, 'swing');
            }
        });

    }

    // imatge ample de punta a punta, dins un contenidor
//    $('img.wide').wrap('<div class="u-wider"></div>')


    // inscripció oferta feina
    if ($('#inscripcion').length) {
    	var formContainer = $(".titulacio_requerida_si");
    	var alertContainer = $("#titulacio_requerida_no");

    	$("#poseeTitulacion").on('change', function(){
    		if (this.value == 1) {
    			formContainer.fadeIn();
    			alertContainer.hide();
    		} else {
    			alertContainer.fadeIn();
    			formContainer.hide();
    		}
    	});

    	if ($("#poseeTitulacion").val() == 0) {
    		formContainer.hide();
    		alertContainer.hide();
    	} else {
    		$("#poseeTitulacion").trigger('change');
    	}

    }

    if ($('#inscripcion').length) {
    	if ($("#trabajabafundacion").val() == 0) {
    		$("#ConvocatoriasPasadas").closest('div.row').hide();
    	}
    	$("#trabajabafundacion").on('change', function(){
    		if (this.value == 1) {
    			$("#ConvocatoriasPasadas").closest('div.row').fadeIn();
    		} else {
    			$("#ConvocatoriasPasadas").closest('div.row').fadeOut();
    		}
    	});
    }

     // inscripció convocatoria OPE
     if ($('#convocatoria-ope').length) {
    	var formContainer = $(".titulacio_requerida_si");
    	var alertContainer = $("#titulacio_requerida_no");

    	$("#poseeTitulacion").on('change', function(){
    		if (this.value == 1) {
    			formContainer.fadeIn();
    			alertContainer.hide();
    		} else {
    			alertContainer.fadeIn();
    			formContainer.hide();
    		}
    	});

    	if ($("#poseeTitulacion").val() == 0) {
    		formContainer.hide();
    		alertContainer.hide();
    	} else {
    		$("#poseeTitulacion").trigger('change');
    	}

    }

    if ($('#convocatoria-ope').length) {
    	if ($("#trabajabafundacion").val() == 0) {
    		$("#ConvocatoriasPasadas").closest('div.row').hide();
    	}
    	$("#trabajabafundacion").on('change', function(){
    		if (this.value == 1) {
    			$("#ConvocatoriasPasadas").closest('div.row').fadeIn();
    		} else {
    			$("#ConvocatoriasPasadas").closest('div.row').fadeOut();
    		}
    	});
    }


    // donació amics IIS La Fe
    if($("#field_60").length) {
    	$("#field_60_other").hide();
    	$("#field_60").on('change', function(){
    		if (this.value == 'others_field') {
    			$("#field_60_other").fadeIn();
    		} else {
    			$("#field_60_other").fadeOut();
    		}
    	});
    }

    // inscripcions cursos
    if ($("#form4").length) {
        $("#form4").validate().settings.submitHandler = function(form) {
            $("#form4 button").addClass('btn--disabled');
        	$("#form4 button").prop('disabled', 'disabled');
            form.submit();
          };
    }
    if ($("#factura").length) {
    	$("#field_140").on('change', function(){
    		$("#factura").toggle();
    	});
    }

    //desplegables +info
    $(".mesinfo__content").hide();
    	$(".mesinfo__bt").on('click', function(){
        $(this).next().toggle();
        //e.preventDefault();
    	});

});
